const setLocation = (location: string) => {
  window.location.href = location;
};

export default setLocation;
